export default {
  app: false,
  clubsite: false,
  store: false,
  memberships: false,
  rewards: false,
  ticketing: false,
  clubtv: false,
  clickcollect: false,
  auctionsite: false
}
